var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flow-common-data-approval"},[(_vm.dataView)?[_c('DataPanelV',_vm._b({},'DataPanelV',_vm.dataView,false))]:[_c('Hint',{attrs:{"type":"empty"}},[_c('div',[_vm._v("流程审批数据为空")])])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }